/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { UpdateSortContactSettingRequestContactSettingsInnerFromJSON, UpdateSortContactSettingRequestContactSettingsInnerToJSON } from './UpdateSortContactSettingRequestContactSettingsInner';
export function UpdateSortCompanySettingRequestFromJSON(json) {
    return UpdateSortCompanySettingRequestFromJSONTyped(json, false);
}
export function UpdateSortCompanySettingRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        companySettings: !exists(json, 'company_settings')
            ? undefined
            : json['company_settings'].map(UpdateSortContactSettingRequestContactSettingsInnerFromJSON)
    };
}
export function UpdateSortCompanySettingRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        company_settings: value.companySettings === undefined
            ? undefined
            : value.companySettings.map(UpdateSortContactSettingRequestContactSettingsInnerToJSON)
    };
}
